import gql from 'graphql-tag';
import { kmsClient } from 'api/apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { AccountsOverviewQuery, AccountsOverviewQueryVariables } from './__generated__/AccountsOverviewQuery';

export const ACCOUNTS_OVERVIEW_QUERY = gql`
  query AccountsOverviewQuery($accountManagerId: ID) {
    accountsOverview(accountManagerId: $accountManagerId) {
      publisher {
        id
        name
        facebookAccountId
        salesForceAccountId
        temporaryHandoff
        temporaryAccountManagerEmail
        spendToday
        spendYesterday
        spendCurrentMonth
        spendPrevMonth
        relativeSpendLastMonth
        discountAmountCurrentMonth
        lastFacebookCostsUpdated
        lastKeyweePixelDataUpdated
        lastFacebookConversionsUpdated
      }
      campaigns {
        id
        name
        notes
        lastModifiedNotesAt
        lastModifiedNotesBy
        platform
        facebookPageLogo
        campaignObjective
        dailyBudget
        endDate
        useCase
        runnerProfile
        riskFactor
        hugoEnabled
        goalCppv
        goalCpa
        budgetSpread
        maxCpa
        targetPricePerAction
        targetSpend
        spendToday
        spendYesterday
        priceToday
        priceYesterday
        priceDayBeforeYesterday
        cpmToday
        cpmYesterday
        cpmDayBeforeYesterday
        remainingBudget
        expectedSpendToday
        discountThisMonth
        lastFacebookCostsUpdated
        lastKeyweePixelDataUpdated
        lastFacebookConversionsUpdated
        violations {
          ended
          smallBudgetLeft
          endsSoon
          overspending
          underspending
          priceSpike
          smallDailyBudget
          closeToBudgetCaps
        }
      }
      accountManager {
        id
        email
      }
      temporaryAccountManager {
        id
        email
      }
    }
  }
`;

export const useAccountsOverviewLazyQuery = () => {
  return useLazyQuery<AccountsOverviewQuery, AccountsOverviewQueryVariables>(ACCOUNTS_OVERVIEW_QUERY, {
    client: kmsClient,
    fetchPolicy: 'no-cache'
  });
};
